import { render, staticRenderFns } from "./RightAngledTrapezoid.vue?vue&type=template&id=6b1fa5c9&scoped=true"
import script from "./RightAngledTrapezoid.vue?vue&type=script&lang=js"
export * from "./RightAngledTrapezoid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1fa5c9",
  null
  
)

export default component.exports